import { useState, useEffect } from 'react';

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from 'react-router-dom';

import Sidebar from './components/sidebar';

import Dashboard from './pages/Dashboard';

import Products from './pages/Products';

import Customers from './pages/Customers';

import AddProduct from './pages/AddProducts';

import Rental from './pages/Rental';

import CustomerDetail from "./pages/CustomerDetail";

import Invoice from "./pages/Invoice";

import RentalDetail from "./pages/RentalDetail";

import Login from './pages/Login';

import ProtectedRoute from './components/ProtectedRoute';
import Quotation from "./pages/Quotation";
import RentalHistory from "./pages/RentalHistory";
import CreditCustomers from './pages/CreditCustomers';
import QuotationHistory from "./pages/QuotationHistory";
// =========================================
// ✅ TOAST NOTIFICATIONS (minimal, app-wide)
// =========================================
// Import { notify } from "../App" and call notify(msg, type).
// <Toaster /> below is mounted once in Layout.

let toastListeners = [];

let toastCounter = 0;

export function notify(message, type = "info") {

  if (!message) return;

  const toast = {
    id: ++toastCounter,
    message: String(message),
    type
  };

  toastListeners.forEach(l => l(toast));
}

export function Toaster() {

  const [toasts, setToasts] = useState([]);

  useEffect(() => {

    const handler = (toast) => {

      setToasts(prev => [...prev, toast]);

      setTimeout(() => {
        setToasts(prev =>
          prev.filter(t => t.id !== toast.id)
        );
      }, 3000);
    };

    toastListeners.push(handler);

    return () => {
      toastListeners =
        toastListeners.filter(l => l !== handler);
    };

  }, []);

  return (

    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-2 pointer-events-none">

      {toasts.map(t => (

        <div
          key={t.id}
          className={`pointer-events-auto px-5 py-3 rounded-xl shadow-lg text-sm font-medium text-white
            ${
              t.type === "success"
                ? "bg-green-600"
                : t.type === "error"
                ? "bg-red-600"
                : "bg-gray-800"
            }`}
        >
          {t.message}
        </div>

      ))}

    </div>
  );
}

// =========================================
// LAYOUT
// =========================================

function Layout() {

  const location =
    useLocation();

  // =========================================
  // HIDE SIDEBAR ON LOGIN
  // =========================================

  const hideSidebar =
    location.pathname === '/login';

  return (

    <div className="flex bg-gray-100 min-h-screen">

      {/* TOASTS */}

      <Toaster />

      {/* SIDEBAR */}

      {!hideSidebar && (
        <Sidebar />
      )}

      {/* CONTENT */}

      <div
  className={`flex-1 ${
    hideSidebar ? "" : "ml-[290px]"
  }`}
>
        <Routes>

          {/* LOGIN */}

          <Route
            path="/login"
            element={<Login />}
          />

          {/* DASHBOARD */}

          <Route
            path="/"
            element={
              <ProtectedRoute>

                <Dashboard />

              </ProtectedRoute>
            }
          />

          {/* PRODUCTS */}

          <Route
            path="/products"
            element={
              <ProtectedRoute>

                <Products />

              </ProtectedRoute>
            }
          />

          {/* ADD PRODUCT */}

          <Route
            path="/add-product"
            element={
              <ProtectedRoute>

                <AddProduct />

              </ProtectedRoute>
            }
          />

          {/* CUSTOMERS */}

          <Route
            path="/customers"
            element={
              <ProtectedRoute>

                <Customers />

              </ProtectedRoute>
            }
          />

          {/* RENTAL */}

          <Route
            path="/rental"
            element={
              <ProtectedRoute>

                <Rental />

              </ProtectedRoute>
            }
          />

          {/* CUSTOMER DETAIL */}

          <Route
            path="/customer/:id"
            element={
              <ProtectedRoute>

                <CustomerDetail />

              </ProtectedRoute>
            }
          />

          {/* RENTAL DETAIL */}

          <Route
            path="/rental/:id"
            element={
              <ProtectedRoute>

                <RentalDetail />

              </ProtectedRoute>
            }
          />

          {/* INVOICE */}

          <Route
            path="/invoice/:id"
            element={
              <ProtectedRoute>

                <Invoice />

              </ProtectedRoute>
            }
          />

          <Route
  path="/quotation"
  element={
    <ProtectedRoute>

      <Quotation />

    </ProtectedRoute>
  }
/>
<Route
  path="/quotation/:id"
  element={
    <ProtectedRoute>
      <Quotation />
    </ProtectedRoute>
  }
/>
<Route
  path="/rental-history"
  element={
    <ProtectedRoute>

      <RentalHistory />

    </ProtectedRoute>
  }
/>
<Route
  path="/credit-customers"
  element={
    <ProtectedRoute>

      <CreditCustomers />

    </ProtectedRoute>
  }
/>
<Route
  path="/quotation-history"
  element={
    <ProtectedRoute>
      <QuotationHistory />
    </ProtectedRoute>
  }
/>

        </Routes>
        

      </div>

    </div>
  );
}

// =========================================
// APP
// =========================================

function App() {

  return (

    <BrowserRouter>

      <Layout />

    </BrowserRouter>
  );
}

export default App;